// extracted by mini-css-extract-plugin
module.exports = {"mainContnt":"bag_mainContnt__00Mct","loading":"bag_loading__Ka3kH","bottomBarContent":"bag_bottomBarContent__rYeYp"};